import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FilterSelect } from "@/components/BookingFilters";
import { AU_STATES } from "@/lib/constants";
import { useSettings } from "@/context/SettingsContext";
import { jobTypeNames, FALLBACK_COLOR } from "@/lib/jobTypes";

export const CalendarFilters = ({ filters, setFilters }) => {
  const { settings } = useSettings();
  const set = (k, v) => setFilters((f) => ({ ...f, [k]: v }));
  const active = Object.values(filters).some(Boolean);
  return (
    <div className="mb-3 grid grid-cols-2 gap-2 rounded-xl border border-slate-200 bg-white p-3 sm:flex sm:flex-wrap sm:items-center" data-testid="calendar-filters">
      <FilterSelect id="cal-job-type" placeholder="Job type" value={filters.job_type} options={jobTypeNames(settings.job_types)} onChange={(v) => set("job_type", v)} />
      <FilterSelect id="cal-state" placeholder="State" value={filters.state} options={AU_STATES} onChange={(v) => set("state", v)} />
      <FilterSelect id="cal-truck" placeholder="Truck" value={filters.truck_assigned} options={settings.trucks} onChange={(v) => set("truck_assigned", v)} />
      <FilterSelect id="cal-team" placeholder="Driver / team" value={filters.assigned_team} options={[...settings.teams, ...(settings.subbies || [])]} onChange={(v) => set("assigned_team", v)} />
      {active && <Button variant="ghost" size="sm" onClick={() => setFilters({ job_type: "", state: "", truck_assigned: "", assigned_team: "" })} data-testid="btn-clear-calendar-filters" className="text-slate-500"><X className="h-4 w-4" /> Clear</Button>}
    </div>
  );
};

export const Legend = () => {
  const { settings } = useSettings();
  const groups = [["Interstate / Share Load", "interstate"], ["Local", "local"]];
  return (
    <div className="mt-4 rounded-xl border border-slate-200 bg-white p-4" data-testid="calendar-legend">
      {groups.map(([label, g]) => (
        <div key={g} className="mb-2 flex flex-wrap items-center gap-x-4 gap-y-1.5 last:mb-0">
          <span className="w-36 text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</span>
          {settings.job_types.filter((t) => t.group === g).map((t) => (
            <span key={t.name} className="inline-flex items-center gap-1.5 text-xs text-slate-700"><span className="h-3 w-3 rounded-full" style={{ background: t.color }} />{t.name}</span>
          ))}
        </div>
      ))}
      <div className="mt-2 flex items-center gap-1.5 text-xs text-slate-500"><span className="h-3 w-3 rounded-full" style={{ background: FALLBACK_COLOR }} />No job type set · Dashed border = On hold · Change colours in Settings → Job types</div>
    </div>
  );
};
